/**
 * Employee credential-expiry helpers.
 *
 * Extracted from EmployeesTab so the Dashboard widget can reuse the
 * same field-mapping and windowing rules without drift.
 */

export const EXPIRY_FIELDS = [
  ['id_card_expiry_date', 'ID Card'],
  ['driving_licence_expiry', 'Driving Licence'],
  ['passport_expiry_date', 'Passport'],
  ['a1_expiry_date', 'A1'],
  ['el_cert_expiry_date', 'Electrical'],
  ['scissor_lift_expiry_date', 'Scissor Lift'],
  ['boom_lift_expiry_date', 'Boom Lift'],
  ['osha_expiry_date', 'OSHA'],
  ['eu_visa_expiry_date', 'EU Visa'],
  ['us_visa_expiry_date', 'US Visa'],
  ['uk_work_permit_expiry_date', 'UK Work Permit'],
];

export const EXPIRY_WINDOW_DAYS = 90;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * Return an ascending list of {field, label, date, days} entries for
 * every credential on `employee` whose expiry date is within
 * `windowDays` from today INCLUDING already-expired ones (negative
 * days). Ordered by days-until-expiry so the most urgent surfaces
 * first.
 */
export const getExpiringCredentials = (employee, windowDays = EXPIRY_WINDOW_DAYS) => {
  const now = Date.now();
  return EXPIRY_FIELDS
    .map(([field, label]) => {
      const raw = employee[field];
      if (!raw) return null;
      const t = new Date(raw).getTime();
      if (Number.isNaN(t)) return null;
      const days = Math.floor((t - now) / MS_PER_DAY);
      if (days > windowDays) return null;
      return { field, label, date: raw, days };
    })
    .filter(Boolean)
    .sort((a, b) => a.days - b.days);
};

/**
 * Format a signed day-delta as a short human string.
 *   3   -> "in 3d"
 *   0   -> "today"
 *  -5   -> "5d ago"
 */
export const formatDaysDelta = (days) => {
  if (days < 0) return `expired ${-days}d ago`;
  if (days === 0) return 'expires today';
  return `in ${days}d`;
};
